export default {
  scmsSetting: [],
  
  buyFactor: [],
  buyFactorById: {},
  buyFactorMaxCode: null,
  buyFactorAttachment: [],
  buyFactorAttachmentById: null,
  buyFactorAddMinus: [],
  readBuyRequestByCode: [],
  readBuyRequestByCommodity: [],

  returnBuyFactor: [],
  returnBuyFactorById: {},
  returnBuyFactorMaxCode: null,
  returnBuyFactorAttachment: [],
  returnBuyFactorAttachmentById: null,
  returnBuyNotes: [],

  latestBuyPriceOfCommodityReport: [],
  factorComprehensiveReport: [],
  commodityComprehensiveReport: [],
  monthlyPurchaseSomeReport: [],
  monthlyPurchaseMonetaryReport: [],

  buyNotes: [],

  buyReportBySuppliers: [],
  buyReportBySuppliersFactorList: [],
  buyReportBySuppliersCommodityList: [],
  buyReportBySuppliersAddMinusList: [],

  buyFactorManagementCartable: [],
  buyReturnManagementCartable: [],
  reqBuyManagementCartable: [],

  reqBuyCartable: [],

  buyFactorCartable: [],

  returnBuyFactorCartable: [],

  factorCalculate: {},

  factorAddMinus: [],

  factorCalculateAddMinus: [],

  cartableLog: [],
};
